import Cookies from 'js-cookie';

const COOKIE_NAME = 'CheckoutPage.upsell';

/**
 * Removes the upsell session cookie.
 *
 * @param {Object} [cookies] Optional cookies object (e.g., from Next.js cookies()).
 * @returns {void}
 */
export default function removeUpsellSession(cookies) {
  if (cookies && typeof cookies.delete === 'function') {
    cookies.delete(COOKIE_NAME);
  } else if (typeof window !== 'undefined') {
    const cookieOptions = {
      secure: true,
      sameSite: 'None',
      path: '/',
    };

    Cookies.remove(COOKIE_NAME, cookieOptions);
  }
}
